[
  {
    "slug": "casa-noura",
    "title": "Casa Noura",
    "industry": "Hospitality",
    "description": "A bilingual English–Arabic desert retreat concept with right-to-left (RTL) support, built around stays, dining, experiences and a calm enquiry-led guest journey.",
    "image": "/images/concepts/casa-noura.webp",
    "tags": [
      "Stay",
      "Experiences",
      "Enquiries"
    ],
    "status": "published",
    "accent": "#9b856f",
    "kind": "concept",
    "serviceTypes": [
      "business-websites"
    ],
    "externalPreviewUrl": null,
    "directHref": "/concepts/casa-noura/",
    "featured": true
  },
  {
    "slug": "studio-orun",
    "title": "Studio Orun",
    "industry": "Architecture & Interiors",
    "description": "A bilingual English–Arabic architecture and interiors studio concept with right-to-left (RTL) support, focused on selected projects, services and a restrained path to contact.",
    "image": "/images/concepts/studio-orun.webp",
    "tags": [
      "Projects",
      "Services",
      "Contact"
    ],
    "status": "published",
    "accent": "#827d73",
    "kind": "concept",
    "serviceTypes": [
      "corporate-websites"
    ],
    "externalPreviewUrl": null,
    "directHref": "/concepts/studio-orun/",
    "featured": true
  },
  {
    "slug": "axiom-industrial",
    "title": "Axiom Industrial",
    "industry": "Industrial Equipment",
    "description": "A B2B industrial sourcing concept built around product families, technical documents and a structured RFQ workflow.",
    "image": "/images/concepts/axiom-industrial.webp",
    "tags": [
      "Catalogue",
      "Downloads",
      "RFQ"
    ],
    "status": "published",
    "accent": "#d9743f",
    "kind": "concept",
    "serviceTypes": [
      "b2b-catalogues-rfq"
    ],
    "externalPreviewUrl": null,
    "directHref": "/concepts/axiom-industrial/",
    "featured": true
  },
  {
    "slug": "veyra-industrial",
    "title": "Veyra Industrial",
    "industry": "Electrical & Industrial Supply",
    "description": "A B2B electrical and industrial supply concept built around product divisions, technical resources and a structured request-for-quote path.",
    "image": "/images/concepts/veyra.webp",
    "tags": [
      "Products",
      "Resources",
      "RFQ"
    ],
    "status": "published",
    "accent": "#2864c7",
    "kind": "concept",
    "serviceTypes": [
      "b2b-catalogues-rfq"
    ],
    "externalPreviewUrl": null,
    "directHref": "/concepts/veyra-industrial/",
    "featured": true
  },
  {
    "slug": "hush-house",
    "title": "Hush House",
    "industry": "Backyard Studios",
    "description": "A calm garden studio concept built around thoughtful space, quiet focus, and a clear path to finding the right studio.",
    "image": "/images/concepts/hush-house.webp",
    "tags": [
      "Positioning",
      "Collection",
      "Enquiries"
    ],
    "status": "published",
    "accent": "#a87555",
    "kind": "concept",
    "serviceTypes": [
      "business-websites"
    ],
    "externalPreviewUrl": null,
    "featured": true
  },
  {
    "slug": "brass-and-blade",
    "title": "Brass & Blade",
    "industry": "Barbershop",
    "description": "A considered barbershop direction built around clear services, precise craft, and a quieter experience in the chair.",
    "image": "/images/concepts/brass-and-blade.webp",
    "tags": [
      "Services",
      "Ritual",
      "Bookings"
    ],
    "status": "published",
    "accent": "#b08a4d",
    "kind": "concept",
    "serviceTypes": [
      "business-websites"
    ],
    "externalPreviewUrl": null,
    "featured": true
  },
  {
    "slug": "forge-auto",
    "title": "Forge Auto",
    "industry": "Independent Auto Repair",
    "description": "A practical auto repair concept focused on careful inspection, understandable recommendations, and evidence-led service.",
    "image": "/images/concepts/forge-auto.webp",
    "tags": [
      "Inspection",
      "Services",
      "Trust"
    ],
    "status": "published",
    "accent": "#bd6d42",
    "kind": "concept",
    "serviceTypes": [
      "business-websites"
    ],
    "externalPreviewUrl": null,
    "featured": true
  },
  {
    "slug": "honey-and-hearth",
    "title": "Honey & Hearth",
    "industry": "Neighbourhood Bakery",
    "description": "A warm bakery concept shaped around fresh bread, small seasonal bakes, and the quiet first hour before the street wakes.",
    "image": "/images/concepts/honey-and-hearth.webp",
    "tags": [
      "Menu",
      "Morning",
      "Local Trust"
    ],
    "status": "published",
    "accent": "#d5a451",
    "kind": "concept",
    "serviceTypes": [
      "business-websites"
    ],
    "externalPreviewUrl": null,
    "featured": true
  },
  {
    "slug": "mirrorline",
    "title": "Mirrorline",
    "industry": "Mobile Car Detailing",
    "description": "A focused mobile detailing concept built around careful exterior care, a cleaner interior, and bringing the process to the car.",
    "image": "/images/concepts/mirrorline.webp",
    "tags": [
      "Results",
      "Convenience",
      "Services"
    ],
    "status": "published",
    "accent": "#6a95a6",
    "kind": "concept",
    "serviceTypes": [
      "business-websites"
    ],
    "externalPreviewUrl": null,
    "featured": true
  }
]
